<!-- <template>
    <div class="fucai3d-container">
      <h1>福彩3D所有可能的号码组合</h1>
      <div class="filters">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="filter-group">
              <label>总跨度剔除: </label>
              <el-input 
                v-model="filters.totalSpan"
                type="number"
                :min="0"
                :max="9"
                placeholder="请输入0-9"
                @input="(val) => handleInput(val, 'totalSpan')"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="filter-group">
              <label>百十跨度剔除: </label>
              <el-input 
                v-model="filters.hundredTenSpan" 
                placeholder="请输入0-9"
                @input="(val) => handleInput(val, 'hundredTenSpan')"
                type="number"
                :min="0"
                :max="9"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="filter-group">
              <label>十个跨度剔除: </label>
              <el-input 
                v-model="filters.tenOneSpan" 
                placeholder="请输入0-9"
                @input="(val) => handleInput(val, 'tenOneSpan')"
                type="number"
                :min="0"
                :max="9"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="filter-group">
              <label>百个跨度剔除: </label>
              <el-input 
                v-model="filters.hundredOneSpan" 
                placeholder="请输入0-9"
                @input="(val) => handleInput(val, 'hundredOneSpan')"
                type="number"
                :min="0"
                :max="9"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        
        <el-row :gutter="20" style="margin-top: 20px;">
          <el-col :span="8">
            <div class="filter-group">
              <label>百位剔除: </label>
              <el-input v-model="filters.excludeHundred" placeholder="如: 1,3,5"></el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="filter-group">
              <label>十位剔除: </label>
              <el-input v-model="filters.excludeTen" placeholder="如: 2,4,6"></el-input>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="filter-group">
              <label>个位剔除: </label>
              <el-input v-model="filters.excludeOne" placeholder="如: 0,8,9"></el-input>
            </div>
          </el-col>
        </el-row>
  
        <div class="filter-actions" style="margin: 20px 0;">
          <el-button type="danger" @click="applyFilters">筛选号码</el-button>
          <el-button type="danger" plain @click="resetFilters">重置条件</el-button>
        </div>
      </div>
      
      <el-divider></el-divider>
      
      <div class="count">
        <el-tag type="info">总组合数: {{ allNumbers.length }}</el-tag>
        <el-tag type="success" style="margin-left: 10px;">已筛选: {{ filteredNumbers.length }}</el-tag>
      </div>
      
      <div class="numbers">
        <el-tag
          v-for="num in filteredNumbers" 
          :key="num"
          style="margin: 4px;"
        >{{ num }}</el-tag>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RemoveNum',
    data() {
      return {
        allNumbers: [],
        currentNumbers: [], // 当前显示的数字
        filters: {
          totalSpan: null,
          hundredTenSpan: null,
          tenOneSpan: null,
          hundredOneSpan: null,
          excludeHundred: '',
          excludeTen: '',
          excludeOne: ''
        }
      }
    },
    created() {
      this.generateFucai3DCombinations()
      this.currentNumbers = [...this.allNumbers] // 初始化当前显示数字
    },
    computed: {
      filteredNumbers() {
        // 这里只返回currentNumbers，不进行实时计算
        return this.currentNumbers
      }
    },
    methods: {
      handleInput(value, field) {
        this.filters[field] = value === '' ? null : Number(value.replace(/\D/g, ''));
      },
      generateFucai3DCombinations() {
        let combinations = []
        for (let i = 0; i <= 999; i++) {
          combinations.push(i.toString().padStart(3, '0'))
        }
        this.allNumbers = combinations
      },
      
      applyFilters() {
        this.currentNumbers = this.allNumbers.filter(num => {
          const [h, t, o] = num.split('').map(Number)
          
          const spanTotal = Math.max(h, t, o) - Math.min(h, t, o)
          const spanHT = Math.abs(h - t)
          const spanTO = Math.abs(t - o)
          const spanHO = Math.abs(h - o)
          
          const excludeH = this.filters.excludeHundred.split(',').map(n => n.trim()).filter(n => n)
          const excludeT = this.filters.excludeTen.split(',').map(n => n.trim()).filter(n => n)
          const excludeO = this.filters.excludeOne.split(',').map(n => n.trim()).filter(n => n)
          
          if (this.filters.totalSpan !== null && spanTotal === this.filters.totalSpan) return false
          if (this.filters.hundredTenSpan !== null && spanHT === this.filters.hundredTenSpan) return false
          if (this.filters.tenOneSpan !== null && spanTO === this.filters.tenOneSpan) return false
          if (this.filters.hundredOneSpan !== null && spanHO === this.filters.hundredOneSpan) return false
          if (excludeH.includes(h.toString())) return false
          if (excludeT.includes(t.toString())) return false
          if (excludeO.includes(o.toString())) return false
          
          return true
        })
        
        this.$message.success(`筛选完成，剩余 ${this.currentNumbers.length} 个号码`)
      },
      
      resetFilters() {
        this.filters = {
          totalSpan: null,
          hundredTenSpan: null,
          tenOneSpan: null,
          hundredOneSpan: null,
          excludeHundred: '',
          excludeTen: '',
          excludeOne: ''
        }
        this.currentNumbers = [...this.allNumbers]
        this.$message.info('已重置所有筛选条件')
      }
    }
  }
  </script>
  
  <style scoped>
  /* 保持原有样式不变 */
  .fucai3d-container {
    max-width: 1200px;
    margin: 20px auto;
    font-family: Arial, sans-serif;
    text-align: center;
    h1{
      color: #f44336;
    }
  }
  .numbers {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
  }
  .count {
    margin: 20px 0;
  }
  .filter-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;
  }
  .filter-group label {
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 14px;
  }
  .filter-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
  }
  </style> -->
  <template>
    <div class="fucai3d-container">
      <h1>福彩3D所有可能的号码组合</h1>
      <div class="filters">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="filter-group">
              <label>总跨度剔除: </label>
              <el-checkbox-group v-model="filters.totalSpan">
                <el-checkbox v-for="n in 10" :key="'ts'+n" :label="n-1">{{n-1}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="filter-group">
              <label>百十跨度剔除: </label>
              <el-checkbox-group v-model="filters.hundredTenSpan">
                <el-checkbox v-for="n in 10" :key="'ht'+n" :label="n-1">{{n-1}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="filter-group">
              <label>十个跨度剔除: </label>
              <el-checkbox-group v-model="filters.tenOneSpan">
                <el-checkbox v-for="n in 10" :key="'to'+n" :label="n-1">{{n-1}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="filter-group">
              <label>百个跨度剔除: </label>
              <el-checkbox-group v-model="filters.hundredOneSpan">
                <el-checkbox v-for="n in 10" :key="'ho'+n" :label="n-1">{{n-1}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
        </el-row>
        
        <el-row :gutter="20" style="margin-top: 20px;">
          <el-col :span="12">
            <div class="filter-group">
              <label>百位剔除: </label>
              <el-checkbox-group v-model="filters.excludeHundred">
                <el-checkbox v-for="n in 10" :key="'h'+n" :label="n-1">{{n-1}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="filter-group">
              <label>十位剔除: </label>
              <el-checkbox-group v-model="filters.excludeTen">
                <el-checkbox v-for="n in 10" :key="'t'+n" :label="n-1">{{n-1}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <div class="filter-group">
              <label>个位剔除: </label>
              <el-checkbox-group v-model="filters.excludeOne">
                <el-checkbox v-for="n in 10" :key="'o'+n" :label="n-1">{{n-1}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </el-col>
        </el-row>
  
        <div class="filter-actions" style="margin: 20px 0;">
          <el-button type="danger" @click="applyFilters">筛选号码</el-button>
          <el-button type="danger" plain @click="resetFilters">重置</el-button>
        </div>
      </div>
      
      <el-divider></el-divider>
      
      <div class="count">
        <el-button 
          type="primary" 
          plain 
          @click="restoreNumbers"
          :disabled="removedNumbers.length === 0"
          style="margin-left: 15px;"
        >
          还原删除({{ removedNumbers.length }})
        </el-button>
        <el-tag type="info" style="margin-left: 10px;">总组合数: {{ allNumbers.length }}</el-tag>
        <el-tag type="success" style="margin-left: 10px;">已筛选: {{ filteredNumbers.length }}</el-tag>
        <el-tag type="warning" style="margin-left: 10px;">点击将移除该条数据</el-tag>
      </div>
      
      <div class="numbers">
        <el-tag
          v-for="num in filteredNumbers" 
          :key="num"
          style="margin: 4px; cursor: pointer;"
          @click="removeNumber(num)"
        >{{ num }}</el-tag>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'RemoveNum',
    data() {
      return {
        allNumbers: [],
        currentNumbers: [],
        removedNumbers: [],
        filters: {
          totalSpan: [],
          hundredTenSpan: [],
          tenOneSpan: [],
          hundredOneSpan: [],
          excludeHundred: [],
          excludeTen: [],
          excludeOne: []
        }
      }
    },
    created() {
      this.generateFucai3DCombinations()
      this.currentNumbers = [...this.allNumbers]
    },
    computed: {
      filteredNumbers() {
        return this.currentNumbers
      }
    },
    methods: {
      generateFucai3DCombinations() {
        let combinations = []
        for (let i = 0; i <= 999; i++) {
          combinations.push(i.toString().padStart(3, '0'))
        }
        this.allNumbers = combinations
      },
      
      applyFilters() {
        this.currentNumbers = this.allNumbers.filter(num => {
          const [h, t, o] = num.split('').map(Number)
          
          const spanTotal = Math.max(h, t, o) - Math.min(h, t, o)
          const spanHT = Math.abs(h - t)
          const spanTO = Math.abs(t - o)
          const spanHO = Math.abs(h - o)
          
          if (this.filters.totalSpan.includes(spanTotal)) return false
          if (this.filters.hundredTenSpan.includes(spanHT)) return false
          if (this.filters.tenOneSpan.includes(spanTO)) return false
          if (this.filters.hundredOneSpan.includes(spanHO)) return false
          if (this.filters.excludeHundred.includes(h)) return false
          if (this.filters.excludeTen.includes(t)) return false
          if (this.filters.excludeOne.includes(o)) return false
          
          return true
        })
        
        this.$message.success(`筛选完成，剩余 ${this.currentNumbers.length} 个号码`)
      },
      
      resetFilters() {
        this.filters = {
          totalSpan: [],
          hundredTenSpan: [],
          tenOneSpan: [],
          hundredOneSpan: [],
          excludeHundred: [],
          excludeTen: [],
          excludeOne: []
        }
        this.currentNumbers = [...this.allNumbers]
        this.removedNumbers = [] // 重置时清空删除记录
        this.$message.info('已重置所有筛选条件')
      },
      
      removeNumber(num) {
        const index = this.currentNumbers.indexOf(num)
        if (index > -1) {
          this.currentNumbers.splice(index, 1)
          this.removedNumbers.push(num) // 将被删除的号码存入数组
          this.$message.success(`已移除号码 ${num}`)
        }
      },
      
      restoreNumbers() {
        if (this.removedNumbers.length > 0) {
          // 取出最后一个被删除的号码（后进先出）
          const numToRestore = this.removedNumbers.pop()
          this.currentNumbers.push(numToRestore)
          this.currentNumbers.sort() // 保持数字有序
          this.$message.success(`已还原号码 ${numToRestore}`)
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .fucai3d-container {
    max-width: 1200px;
    margin: 20px auto;
    font-family: Arial, sans-serif;
    text-align: center;
  }
  .fucai3d-container h1 {
    color: #f44336;
  }
  .numbers {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
  }
  .count {
    margin: 20px 0;
  }
  .filter-group {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;
  }
  .filter-group label {
    margin-bottom: 5px;
    font-weight: bold;
    font-size: 14px;
  }
  .filter-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
  }
  .el-checkbox-group {
    display: flex;
    flex-wrap: wrap;
  }
  .el-checkbox {
    margin-right: 10px;
    margin-bottom: 5px;
  }
  </style>


// WEBPACK FOOTER //
// src/views/usingTools/removeNum.vue